const Image = {
	baseStyle: {
		loading: "lazy",
		alt: "Symbolbild",
	},
};

export default Image;
